var map = {
	"./address.png": 53509,
	"./back-up.png": 55641,
	"./corporate-vision.png": 64114,
	"./email.png": 5298,
	"./map.png": 97657,
	"./map_en.png": 48358,
	"./phone.png": 71278,
	"./wechat.png": 18265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32951;